import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {VapService} from '../../../services/vap.service';
import {GlobalQuestionService} from '../../../services/global-question.service';
import {QuotePageDataVaps} from '../../../models/quote.model';
import {VapParentQuestion} from '../../../models/vap-parent-question';
import {MiniFlowSavedItems} from '../../../models/mini-flow-saved-items';

@Component({
    selector: 'app-vaps-mini-flow-parent',
    templateUrl: './vaps-mini-flow-parent.component.html',
    styleUrls: ['./vaps-mini-flow-parent.component.scss'],
    standalone: false
})
export class VapsMiniFlowParentComponent implements OnInit, OnChanges {

  @Input() vap: QuotePageDataVaps;
  @Input() vapQuestion: VapParentQuestion;
  @Input() productId: number;
  @Input() isEdit = false;
  @Output() itemsChanged = new EventEmitter<MiniFlowSavedItems[]>();

  lastItemId = '';
  editItemId = '';
  miniFlowSavedItems: MiniFlowSavedItems[] = [];
  showAddAnother = true;

  constructor(private vapService: VapService, public questionService: GlobalQuestionService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.vap?.currentValue !== changes?.vap?.previousValue) {
      this.vap = changes?.vap?.currentValue;
    }
    if (changes?.vapQuestion?.currentValue !== changes?.vapQuestion?.previousValue) {
      this.vapQuestion = changes?.vapQuestion?.currentValue;
    }
    if (changes?.productId?.currentValue !== changes?.productId?.previousValue) {
      this.productId = changes?.productId?.currentValue;
    }
    if (changes?.isEdit?.currentValue !== changes?.isEdit?.previousValue) {
      this.isEdit = changes?.isEdit?.currentValue;
    }
    this.loadSavedItems();
  }

  loadSavedItems(): void {
    if (this.vap?.product_vaps_id && this.vap?.class_id >= 0) {
      this.lastItemId = '';
      this.editItemId = '';
      this.vapService.getMiniFlowItems(this.vap?.product_vaps_id, this.vap?.class_id, this.vapQuestion?.child_flow_id, this.vapQuestion?.child_question_id)
        .subscribe({
          next: s => {
            this.miniFlowSavedItems = s;
            //console.log(this.miniFlowSavedItems)
            this.miniFlowSavedItems = this.miniFlowSavedItems?.sort((a, b) => +a?.item_id - +b?.item_id);
            if (this.miniFlowSavedItems?.length) {
              this.itemsChanged.emit(this.miniFlowSavedItems);
              for (const item of this.miniFlowSavedItems) {
                this.lastItemId = item?.item_id;
              }
              this.showAddAnother = this.miniFlowSavedItems?.some(m => +m?.add_another === 1);
            } else {
              this.showAddAnother = true;
              this.lastItemId = '0';
              this.itemsChanged.emit([]);
            }
          }
        });
    }
  }

  edit(item_id: string): void {
    this.editItemId = item_id;
    this.lastItemId = '';
  }

  removeBenefit(item_id: string): void {
    this.vapService.removeBenefit(this.vap?.class_id, this.vap?.product_vaps_id, item_id)
      .subscribe({
        next: () => {
          setTimeout(() => {
            this.loadSavedItems();
          }, 2000);
        }
      });
  }

  onFlowComplete(event: boolean): void {
    if (event) {
      setTimeout(() => {
        this.loadSavedItems();
      }, 2000);
    }
  }

}
